var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIAvnKebabMenu = function SvgIAvnKebabMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#9D9BDA",
    "data-no-stroke": "true"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 10,
    r: 2,
    fill: "#9D9BDA",
    "data-no-stroke": "true"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 18,
    r: 2,
    fill: "#9D9BDA",
    "data-no-stroke": "true"
  })));
};
export { SvgIAvnKebabMenu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgY3g9IjIiIGN5PSIyIiByPSIyIiBmaWxsPSIjOUQ5QkRBIiBkYXRhLW5vLXN0cm9rZT0idHJ1ZSIvPgogICAgPGNpcmNsZSBjeD0iMiIgY3k9IjEwIiByPSIyIiBmaWxsPSIjOUQ5QkRBIiBkYXRhLW5vLXN0cm9rZT0idHJ1ZSIvPgogICAgPGNpcmNsZSBjeD0iMiIgY3k9IjE4IiByPSIyIiBmaWxsPSIjOUQ5QkRBIiBkYXRhLW5vLXN0cm9rZT0idHJ1ZSIvPgo8L3N2Zz4=";